const master = {
  zlinkAPI: 'https://zlink.wenyanmedia.com',
  permitAPI: 'https://permit.xq5.com',
  emsSrv: 'https://ems-srv.xq5.com/event-api', // 服务接口域名
  getSubGameApi: 'https://deployapi.xq5.com/web/v3/app-name-git',
  gameListAPI: 'https://configapi.xq5.com/v2/game/list',
  gameAreaListAPI: 'https://configapi.xq5.com/v2/game/area/list',
  txCloudAPI: 'https://qcloudcosapi.xq5.com',
  pandoraAPI: 'https://pandora-xq5.zonst.com',
  // 张宇锋
  wxOpappApi: 'https://xyxcourse.xq5.com/api2', // 配置
  wxOpappDataApi: 'https://xyxcourse.xq5.com/recode/v2', // 数据
  wxTriggerApi: 'https://xyxcourse.xq5.com/trigger', //  触发事件礼包

  WhiteListAPI: 'https://xyxcourse.xq5.com', // 白名单
  // authpermissionAPI: 'https://xyxcourse.xq5.com', // 权限管理
  authpermissionAPI: 'https://authority.xq5.com', // 权限管理(新)

  daZhuanPanApi: 'https://xyxdzp.xq5.com', // 大转盘

  xyxUpdateApi: 'https://xyx.zonst.com/update', // 版本
  wxInviteApi: 'https://xyx.zonst.com/invite', // 邀请活动
  xyxD2Api: 'https://xyxd2.zonst.com', // 新年礼包和ios索要

  // 冯涛
  xyxZonstApi: 'https://xyx.zonst.com',
  // propAPI: 'https://xyx.zonst.com/api', // 后台服务
  propAPI: 'https://server-leisure-minigame-admin.xq5.com/api', // propAPI迁移服务
  outTxtApi: 'https://xyx.zonst.com/api', // 投放码导出接口
  // errorAPI: 'https://xyx.zonst.com/err', // 错误
  errorAPI: 'https://server-leisure-minigame-admin.xq5.com/err', // errorAPI迁移服务
  // payAPI: 'https://xyx.zonst.com/pay', // 支付服务
  payAPI: 'https://xyxorderapisrv.xq5.com/pay', // 支付服务
  // fluCard: 'https://xyx.zonst.com/api', // 福卡配置
  fluCard: 'https://server-leisure-minigame-admin.xq5.com/api', // fluCard迁移服务

  // 其他服务
  sportMeetAPI: 'https://sportmeet2ndapi.xq5.com/config2',
  clubopapiAPI: 'https://clubopapi.xq5.com', // 用户留存
  chongzhiAPI: 'https://financeapi.xq5.com', // 充值信息
  matchAPI: 'https://matchapi.xq5.com', // 比赛服务 （原配置后台）
  goldFeildAPI: 'https://coinplaceapi.xq5.com', // 金币场
  adaptiveScoreAPI: 'https://coinplaceapi.xq5.com', // 金币场
  robotAPI: 'https://robotclientapi.xq5.com',                 // 机器人分配地址(测试服)
  clubopapi: 'https://clubopapi.xq5.com',
  matchInfoAPI: 'https://matchapi.xq5.com',                   // 比赛场信息(原配置后台)
  foodAPI: 'https://h5api.4417.com/foodaward',
  operatorAPI: 'https://login.xq5.com',                       // 操作人信息
  ksclientAPI: 'https://ksclientapi.xq5.com',                 // 获取用户金币数量

  // 英生
  pokerSetAPI: 'https://xyxcard.xq5.com',                     // 牌库配置接口

  logApi: 'https://log.zzect.com/api/v1',                    // 日志服务
  xyxNewDataApi: 'https://xyxdata.xq5.com',                  // 行为上报
  taskSetApi: 'https://xyx.zzect.com',                       // 任务配置
  robotGoldApi: 'https://xyx.zzect.com',                     // 机器人金币控制
  eventApi: 'https://xyxdata.xq5.com',                       // 事件配置
  // liveGameApi: 'https://xyx.zzect.com',                      // 线下赛事配置
  liveGameApi: 'https://server-leisure-minigame-admin.xq5.com', // 线下赛事配置域名迁移
  mjLibApi: 'https://cardlib.zzect.com',                     // 麻将牌库
  middlegroundapi: 'https://middlegroundapi.xq5.com/middlegroundapisrv',

  kamiapisrvAPI: 'https://kamiapisrv.xq5.com/kamiapisrv',
  xyxpropapisrvAPI: 'https://xyxpropapisrv.xq5.com/xyxpropapisrv',
  matchhonoursAPI: 'https://gateway.xq5.com/matchhonoursapisrv', // 智运会服务
  kamiwatchsrvAPI: 'https://kamiwatchsrv.xq5.com', // 卡密道具类型绑定配置
  challengeApi: 'https://gateway.xq5.com/challengeapisrv',

  // 活动
  activeConfigApi: 'https://gateway.xq5.com/middlegroundapisrv',
  // 控牌配置 -- fuyifan
  controlCardApi: 'https://coinplacewinlosssrv.xq5.com/coinplacewinlosssrv',
  // 子游戏顺序配置（yufan）
  gameAreaSortApi: 'https://gateway.xq5.com/xyxuserapisrv',
  // 发牌策略 -- fuyifan
  dealStrategyApi: 'https://xyxdata.xq5.com/v2',
  // 用户策略
  userLabelApi: 'https://userlabelapisrv.xq5.com',
  userLabelApiNew: 'https://server-leisure-minigame-admin.xq5.com/api',
  // 限时秒杀后台接口
  limittimeactivityApi: 'https://limittimeactivityapisrv.xq5.com/limittimeactivityapisrv',
  // 每日库存 -熊其明
  dailyStockApi: 'https://proplimitapisrv.xq5.com/proplimitapisrv',
  // 游戏包配置
  gamePackageApi: 'https://gateway.xq5.com/xyxbackendapisrv',
  signInAPI: 'https://middlegroundapi.xq5.com',
  backUserTaskConfig: 'https://gateway.xq5.com',
  // 拉新活动配置
  laxinApi: 'https://middlegroundapi.xq5.com/middlegroundapisrv',
  // 求签祈福
  drawLotApi: 'https://server-leisure-minigame-admin.xq5.com/api',
  //广告误触配置/对局有礼配置
  bannerTouchConfig:'https://middlegroundapi.xq5.com/middlegroundapisrv',
  //洗牌配置
  shuffleConfig: 'https://server-leisure-minigame-admin.xq5.com',
  //活动强弹配置
  strongConfig:'https://server-leisure-minigame-admin.xq5.com/api',
  // 第三方联运
  thirdPartyGameApi: 'https://server-leisure-minigame-admin.xq5.com/api'
};

// 测试环境
const dev = {
  zlinkAPI: 'http://zlink.test.zonst.com',
  permitAPI: 'http://permit.test.zonst.com',
  emsSrv: 'http://129.211.113.36:10010/dev/event-api', // 服务接口域名
  pandoraAPI: 'http://pandora.test.zonst.com',
  // authpermissionAPI: 'https://xyxcourse.xq5.com', // 权限管理
  // authpermissionAPI: 'http://123.206.215.185:9431', // 权限管理 (新)
  getSubGameApi: 'http://serverdeployapisrv.test.xq5.com/web/v3/app-name-git',
  authpermissionAPI: 'http://authorityapisrv.test.xq5.com', // 权限管理 (替换k8s域名)

  gameListAPI: 'https://configapi.xq5.com/v2/game/list', // 游戏平台
  gameAreaListAPI: 'http://gameconfigapisrv.test.xq5.com/v1/game/area/list', // 子游戏
  // gameAreaListAPI: 'http://gameconfigapisrv2.test.xq5.com/v1/game/area/list', // 子游戏(替换k8s域名)
  // gameAreaListAPI: 'https://configapi.xq5.com/v2/game/area/list', // 子游戏(替换k8s域名)
  txCloudAPI: 'https://qcloudcosapi.xq5.com', // 腾讯云

  xyxZonstApi: 'https://xyx.zonst.com',
  // 张宇锋
  // wxOpappApi: 'http://129.211.113.36:8868/api2', // 配置
  wxOpappApi: 'http://statisticsapisrv.test.xq5.com/api2', // 配置(替换k8s域名)
  wxOpappDataApi: 'http://wxrecodeappsrv.test.xq5.com/recode/v2', // 数据
  wxTriggerApi: 'http://eventtriggersrv.test.xq5.com/trigger', //  触发事件礼包
  wxInviteApi: 'https://xyx.zonst.com/invite', // 邀请活动
  xyxD2Api: 'https://xyxd2.zonst.com', // 新年礼包和ios索要
  daZhuanPanApi: 'http://dazhuanpansrv.test.xq5.com', // 大转盘
  // xyxUpdateApi: 'http://129.211.113.36:8889/update', // 版本
  WhiteListAPI: 'http://gamecourseapisrv.test.xq5.com', // 白名单

  // 冯涛
  // propAPI: 'http://test.xyx.xq5.com/dev/api', // 后台服务
  propAPI: 'http://server-leisure-minigame-admin.test.xq5.com/dev/api', // propAPI迁移服务
  outTxtApi: 'https://xyx.zonst.com/api', // 投放码导出接口
  // fluCard: 'https://xyx.zonst.com/dev/api', // 福卡配置
  // errorAPI: 'https://xyx.zonst.com/dev/err', // 错误
  // payAPI: 'https://xyx.zonst.com/dev/pay', // 支付服务

  // fluCard: 'http://test.xyx.xq5.com/dev/api', // 福卡配置
  fluCard: 'http://server-leisure-minigame-admin.test.xq5.com/dev/api', // fluCard迁移服务
  // errorAPI: 'http://test.xyx.xq5.com/dev/err', // 错误
  errorAPI: 'http://server-leisure-minigame-admin.test.xq5.com/dev/err', // errorAPI迁移服务
  // payAPI: 'http://129.211.113.36:8110/dev/pay', // 支付服务
  payAPI: 'http://xyxorderapisrv.test.xq5.com/dev/pay', // 支付服务(替换k8s域名)

  // sportMeetAPI: 'http://123.206.215.185:9981/config2',
  clubopapiAPI: 'https://clubopapi.xq5.com', // 用户留存

  chongzhiAPI: 'https://financeapi.xq5.com', // 充值信息
  // goldFeildAPI: 'http://coinplaceapisrv.test.xq5.com', // 金币场
  adaptiveScoreAPI: 'http://coinplaceapisrv.test.xq5.com',
  goldFeildAPI: 'http://coinplaceapisrv.test.xq5.com', // 金币场(替换k8s域名)
  // robotAPI: 'http://115.159.101.234:9601', // 机器人分配地址(测试服)
  robotAPI: 'http://robotclientapisrv.test.xq5.com', // 机器人分配地址(测试服)(替换k8s域名)
  // clubopapi: 'http://123.206.215.185:9031',
  clubopapi: 'http://clubopapisrv.test.xq5.com', // (替换k8s域名)
  // matchInfoAPI: 'http://123.206.215.185:9101', // 比赛场信息(测试服, 原配置后台)
  matchInfoAPI: 'http://matchmgrapisrv.test.xq5.com', // 比赛场信息(测试服, 原配置后台)(替换k8s域名)
  // matchAPI: 'http://123.206.215.185:9101',
  matchAPI: 'http://matchmgrapisrv.test.xq5.com', // (替换k8s域名)

  foodAPI: 'https://h5api.4417.com/foodaward',
  operatorAPI: 'https://login.xq5.com', // 操作人信息
  ksclientAPI: 'http://ksclientapisrv.test.xq5.com', // 获取用户金币数量
  // agentlistapp: 'http://123.206.215.185:9140', // 获取用户金币数量(dev)

  // 英生
  pokerSetAPI: 'http://cardlibrarysrv.test.xq5.com', // 牌库配置接口

  logApi: 'http://xyx_log_srv.test.xq5.com/api/v1',            // 日志服务
  xyxNewDataApi: 'http://xyxopdatatest.xq5.com',            // 行为上报
  taskSetApi: 'http://xyxtasksrv.test.xq5.com',              // 任务配置(替换k8s域名)
  robotGoldApi: 'http://gameaisrv.test.xq5.com',             // 机器人金币控制
  eventApi: 'http://xyxopdatatest.xq5.com',                 // 事件配置
  // liveGameApi: 'https://xyx.zonst.com/dev',               // 线下赛事配置
  // liveGameApi: 'http://test.xyx.xq5.com/dev',               // 线下赛事配置
  liveGameApi: 'http://server-leisure-minigame-admin.test.xq5.com/dev', // 线下赛事配置域名迁移
  mjLibApi: 'http://mahjongcardlibsrv.test.xq5.com',                 // 麻将牌库
  middlegroundapi: 'http://middlegroundapisrv.test.xq5.com/middlegroundapisrv',
  signInAPI: 'http://middlegroundapisrv.test.xq5.com',              // 签到配置
  backUserTaskConfig: 'http://xyx_task_srv.test.xq5.com',              // 回归任务配置

  // kamiapisrvAPI: 'http://129.211.113.36:8147/kamiapisrv',
  kamiapisrvAPI: 'http://kamiapisrv.test.xq5.com/kamiapisrv', // (替换k8s域名)
  xyxpropapisrvAPI: 'http://xyxpropapisrv.test.xq5.com/xyxpropapisrv',

  matchhonoursAPI: 'http://matchhonoursapisrv.test.xq5.com/matchhonoursapisrv',  // 智运会服务

  // 活动
  activeConfigApi: 'http://middlegroundapisrv.test.xq5.com/middlegroundapisrv',

  // kamiwatchsrvAPI: 'http://129.211.113.36:8148', // 卡密道具类型绑定配置
  kamiwatchsrvAPI: 'http://kamiwatchsrv.test.xq5.com', // 卡密道具类型绑定配置 (替换k8s域名)
  // 子游戏顺序配置（yufan）
  // gameAreaSortApi: 'http://129.211.113.36:10088/dev/xyxuserapisrv',
  gameAreaSortApi: 'http://xyxuserapisrv.test.xq5.com/dev/xyxuserapisrv', // (替换k8s域名)
  // 控牌配置 -- fuyifan
  controlCardApi: 'http://coinplacewinlosssrv.test.xq5.com/coinplacewinlosssrv',
  // 发牌策略 -- fuyifan
  dealStrategyApi: 'http://xyxopdatatest.xq5.com/v2',
  challengeApi: 'http://challengeapisrv.test.xq5.com/challengeapisrv',
  // 用户策略
  // userLabelApi: 'http://userlabelapisrv.test.xq5.com',
  userLabelApi: 'http://userlabelapisrv.test.xq5.com',
  userLabelApiNew: 'http://server-leisure-minigame-admin.test.xq5.com/dev/api',
  // 限时秒杀后台接口
  limittimeactivityApi: 'http://limittimeactivityapisrv.test.xq5.com/limittimeactivityapisrv',
  // 每日库存 熊其明
  dailyStockApi: 'http://proplimitapisrv.test.xq5.com/proplimitapisrv',
   // 游戏包配置
  gamePackageApi: 'http://xyxbackendapisrv.test.xq5.com/xyxbackendapisrv',
  // gamePackageApi: 'http://xyxbackendapisrv.test.xq5.com/git.xq5.com/xiaoyouxi/xyxbackendapisrv',
  // 拉新活动配置
  laxinApi: 'http://middlegroundapisrv.test.xq5.com/middlegroundapisrv',
// 求签祈福
  drawLotApi: 'http://server-leisure-minigame-admin.test.xq5.com/dev/api',
  laXinApiNew: 'http://server-leisure-minigame-admin.test.xq5.com',
  //广告误触配置/对局有礼配置
  bannerTouchConfig:'http://middlegroundapisrv.test.xq5.com/middlegroundapisrv',
  //洗牌配置
  shuffleConfig: 'http://server-leisure-minigame-admin.test.xq5.com/dev',
   //活动强弹配置
  strongConfig:'http://server-leisure-minigame-admin.test.xq5.com/dev/api',
  // 第三方联运
  thirdPartyGameApi: 'http://server-leisure-minigame-admin.test.xq5.com/dev/api'
};

// 鹰潭(新环境)正式环境 xq556
const masternew = {
  zlinkAPI: 'https://zlink.wenyanmedia.com',
  permitAPI: 'https://permit.xq5.com',
  emsSrv: 'https://ems-srv.xq5.com/event-api', // 服务接口域名
  getSubGameApi: 'https://deployapi.xq556.com/web/v3/app-name-git',
  controlCardApi: 'https://coinplacewinlosssrv.xq5.com/coinplacewinlosssrv',
  gameListAPI: 'https://configapi.xq556.com/v2/game/list',
  gameAreaListAPI: 'https://configapi.xq556.com/v2/game/area/list',
  txCloudAPI: 'https://qcloudcosapi.xq5.com',
  wxOpappApi: 'https://xyxcourse.xq556.com/api2', // 配置
  wxOpappDataApi: 'https://xyxcourse.xq556.com/recode/v2', // 数据
  wxTriggerApi: 'https://xyxcourse.xq556.com/trigger', //  触发事件礼包
  WhiteListAPI: 'https://xyxcourse.xq556.com', // 白名单
  authpermissionAPI: 'https://authority.xq556.com', // 权限管理(新)
  daZhuanPanApi: 'https://xyxdzp.xq556.com', // 大转盘
  xyxUpdateApi: 'https://xyx.xq556.com/update', // 版本
  wxInviteApi: 'https://xyx.xq556.com/invite', // 邀请活动
  xyxD2Api: 'https://xyxd2.zonst.com', // 新年礼包和ios索要
  xyxZonstApi: 'https://xyx.xq556.com',
  // propAPI: 'https://xyx.xq556.com/api', // 后台服务
  propAPI: 'https://server-leisure-minigame-admin.xq556.com/api', // propAPI迁移服务
  outTxtApi: 'https://xyx.xq556.com/api', // 投放码导出接口
  // errorAPI: 'https://xyx.xq556.com/err', // 错误
  errorAPI: 'https://server-leisure-minigame-admin.xq556.com/err', // errorAPI迁移服务
  payAPI: 'https://xyx.xq556.com/pay', // 支付服务
  // fluCard: 'https://xyx.xq556.com/api', // 福卡配置
  fluCard: 'https://server-leisure-minigame-admin.xq556.com/api', // fluCard迁移服务
  sportMeetAPI: 'https://sportmeet2ndapi.xq556.com/config2',
  clubopapiAPI: 'https://clubopapi.xq556.com',                  // 用户留存
  chongzhiAPI: 'https://financeapi.xq556.com',                  // 充值信息
  matchAPI: 'https://matchapi.xq556.com',                       // 比赛服务 （原配置后台）
  goldFeildAPI: 'https://coinplaceapi.xq556.com',               // 金币场
  adaptiveScoreAPI: 'https://coinplaceapi.xq556.com',
  robotAPI: 'https://robotclientapi.xq556.com',                 // 机器人分配地址(测试服)
  clubopapi: 'https://clubopapi.xq556.com',
  matchInfoAPI: 'https://matchapi.xq556.com',                   // 比赛场信息(原配置后台)
  foodAPI: 'https://h5api.4417.com/foodaward',
  operatorAPI: 'https://login.xq556.com',                       // 操作人信息
  ksclientAPI: 'https://ksclientapi.xq556.com',                 // 获取用户金币数量
  pokerSetAPI: 'https://xyxcard.xq556.com',                     // 牌库配置接口
  logApi: 'https://log.zzect.com/api/v1',                    // 日志服务
  xyxNewDataApi: 'https://xyxdata.xq556.com',                  // 行为上报
  taskSetApi: 'https://xyxtasksrv.xq556.com',                       // 任务配置
  robotGoldApi: 'https://xyx.xq556.com',                     // 机器人金币控制
  eventApi: 'https://xyxdata.xq556.com',                       // 事件配置
  // liveGameApi: 'https://xyx.xq556.com',                      // 线下赛事配置
  liveGameApi: 'https://server-leisure-minigame-admin.xq556.com', // 线下赛事配置域名迁移
  mjLibApi: 'https://cardlib.zzect.com',                     // 麻将牌库
  middlegroundapi: 'https://middlegroundapi.xq556.com/middlegroundapisrv',

  kamiapisrvAPI: 'https://kamiapisrv.xq5.com/kamiapisrv',
  xyxpropapisrvAPI: 'https://xyxpropapisrv.xq556.com/xyxpropapisrv',
  matchhonoursAPI: 'https://gateway.xq556.com/matchhonoursapisrv',  // 智运会服务

  activeConfigApi: 'https://gateway.xq556.com/middlegroundapisrv',
  challengeApi: 'https://gateway.xq556.com/challengeapisrv',

  kamiwatchsrvAPI: 'https://kamiwatchsrv.xq5.com', // 卡密道具类型绑定配置
  gameAreaSortApi: 'https://gateway.xq5.com/xyxuserapisrv',
  // 限时秒杀后台接口
  limittimeactivityApi: 'https://limittimeactivityapisrv.xq556.com/limittimeactivityapisrv',
  // 游戏包配置
  gamePackageApi: 'https://gateway.xq556.com/xyxbackendapisrv',
  signInAPI: 'https://middlegroundapi.xq556.com',
  backUserTaskConfig: 'https://gateway.xq556.com',
  laxinApi: 'https://middlegroundapi.xq556.com/middlegroundapisrv',
  drawLotApi: 'https://server-leisure-minigame-admin.xq556.com/api',
  //广告误触配置/对局有礼配置
  bannerTouchConfig:'https://middlegroundapi.xq556.com/middlegroundapisrv',
  //洗牌配置
  shuffleConfig: 'https://server-leisure-minigame-admin.xq556.com',
  //活动强弹配置
  strongConfig:'https://server-leisure-minigame-admin.xq556.com/api',
  // 第三方联运
  thirdPartyGameApi: 'https://server-leisure-minigame-admin.xq556.com/api',
  userLabelApiNew: 'https://server-leisure-minigame-admin.xq5.com/api',
}
// 省外正式环境  xq668
const mastersw = {
  zlinkAPI: 'https://zlink.wenyanmedia.com',
  permitAPI: 'https://permit.xq5.com',
  emsSrv: 'https://ems-srv.xq5.com/event-api', // 服务接口域名
  getSubGameApi: 'https://deployapi.xq668.com/web/v3/app-name-git',
  controlCardApi: 'https://coinplacewinlosssrv.xq5.com/coinplacewinlosssrv',
  gameListAPI: 'https://configapi.xq668.com/v2/game/list',
  gameAreaListAPI: 'https://configapi.xq668.com/v2/game/area/list',
  txCloudAPI: 'https://qcloudcosapi.xq668.com',
  wxOpappApi: 'https://xyxcourse.xq668.com/api2', // 配置
  wxOpappDataApi: 'https://xyxcourse.xq668.com/recode/v2', // 数据
  wxTriggerApi: 'https://xyxcourse.xq668.com/trigger', //  触发事件礼包
  WhiteListAPI: 'https://xyxcourse.xq668.com', // 白名单
  authpermissionAPI: 'https://authority.xq668.com', // 权限管理(新)
  daZhuanPanApi: 'https://xyxdzp.xq668.com', // 大转盘
  xyxUpdateApi: 'https://xyx.xq668.com/update', // 版本
  wxInviteApi: 'https://xyx.xq668.com/invite', // 邀请活动
  xyxD2Api: 'https://xyxd2.zonst.com', // 新年礼包和ios索要
  xyxZonstApi: 'https://xyx.xq668.com',
  // propAPI: 'https://xyx.xq668.com/api', // 后台服务
  propAPI: 'https://server-leisure-minigame-admin.xq668.com/api', // propAPI迁移服务
  outTxtApi: 'https://xyx.xq668.com/api', // 投放码导出接口
  // errorAPI: 'https://xyx.xq668.com/err', // 错误
  errorAPI: 'https://server-leisure-minigame-admin.xq668.com/err', // errorAPI迁移服务
  payAPI: 'https://xyx.xq668.com/pay', // 支付服务
  // fluCard: 'https://xyx.xq668.com/api', // 福卡配置
  fluCard: 'https://server-leisure-minigame-admin.xq668.com/api', // fluCard迁移服务
  sportMeetAPI: 'https://sportmeet2ndapi.xq668.com/config2',
  clubopapiAPI: 'https://clubopapi.xq668.com', // 用户留存
  chongzhiAPI: 'https://financeapi.xq668.com', // 充值信息
  matchAPI: 'https://matchapi.xq668.com', // 比赛服务 （原配置后台）
  goldFeildAPI: 'https://coinplaceapi.xq668.com',               // 金币场
  adaptiveScoreAPI: 'https://coinplaceapi.xq668.com',               // 金币场
  robotAPI: 'https://robotclientapi.xq668.com',                 // 机器人分配地址(测试服)
  clubopapi: 'https://clubopapi.xq668.com',
  matchInfoAPI: 'https://matchapi.xq668.com',     // 比赛场信息(原配置后台)
  foodAPI: 'https://h5api.4417.com/foodaward',
  operatorAPI: 'https://login.xq5.com',                       // 操作人信息
  ksclientAPI: 'https://ksclientapi.xq668.com',                 // 获取用户金币数量
  pokerSetAPI: 'https://xyxcard.xq668.com',                     // 牌库配置接口
  logApi: 'https://log.zzect.com/api/v1',                    // 日志服务
  xyxNewDataApi: 'https://xyxdata.xq668.com',                  // 行为上报
  taskSetApi: 'https://xyxtasksrv.xq668.com',                       // 任务配置
  robotGoldApi: 'https://xyx.xq668.com',                     // 机器人金币控制
  eventApi: 'https://xyxdata.xq668.com',                       // 事件配置
  // liveGameApi: 'https://xyx.xq668.com',                      // 线下赛事配置
  liveGameApi: 'https://server-leisure-minigame-admin.xq668.com', // 线下赛事配置域名迁移
  mjLibApi: 'https://cardlib.zzect.com',
  middlegroundapi: 'https://middlegroundapi.xq668.com/middlegroundapisrv',

  kamiapisrvAPI: 'https://kamiapisrv.xq5.com/kamiapisrv',
  xyxpropapisrvAPI: 'https://xyxpropapisrv.xq668.com/xyxpropapisrv',
  matchhonoursAPI: 'https://gateway.xq668.com/matchhonoursapisrv',  // 智运会服务
  challengeApi: 'https://gateway.xq668.com/challengeapisrv',

  activeConfigApi: 'https://gateway.xq668.com/middlegroundapisrv',

  kamiwatchsrvAPI: 'https://kamiwatchsrv.xq5.com', // 卡密道具类型绑定配置
  gameAreaSortApi: 'https://gateway.xq5.com/xyxuserapisrv',
  // 限时秒杀后台接口
  limittimeactivityApi: 'https://limittimeactivityapisrv.xq668.com/limittimeactivityapisrv',
  // 游戏包配置
  gamePackageApi: 'https://gateway.xq668.com/xyxbackendapisrv',
  signInAPI: 'https://middlegroundapi.xq668.com',
  backUserTaskConfig: 'https://gateway.xq668.com',
  laxinApi: 'https://middlegroundapi.xq668.com/middlegroundapisrv',
  drawLotApi: 'https://server-leisure-minigame-admin.xq668.com/api',
  //广告误触配置/对局有礼配置
  bannerTouchConfig:'https://middlegroundapi.xq668.com/middlegroundapisrv',
  //洗牌配置
  shuffleConfig: 'https://server-leisure-minigame-admin.xq668.com',
  //活动强弹配置
  strongConfig:'https://server-leisure-minigame-admin.xq668.com/api',
  // 第三方联运
  thirdPartyGameApi: 'https://server-leisure-minigame-admin.xq668.com/api',
  userLabelApiNew: 'https://server-leisure-minigame-admin.xq5.com/api',
}

// 省外测试环境
const devsw = dev
// 鹰潭测试环境
const devnew = dev

module.exports = { master, dev, mastersw, devsw, masternew, devnew };
